import React from 'react';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';
import pictureEn from 'oldAssets/images/static_pages/our_mission/OurValues_en.webp';
import pictureDe from 'oldAssets/images/static_pages/our_mission/OurValues_de.webp';
import styles from './OurValues.module.scss';

const OurValues = ({ title, locale }) => {
  const picture = locale === 'de' ? pictureDe : pictureEn;
  return ( 
    <BaseSection
      title={ title }
      anchor='our-values'
      headerType='simple'
    >
      <figure className={ styles.OurValues }>
        <img src={ picture } />
      </figure>
    </BaseSection>
  );
};
 
export default OurValues;